import React from 'react';

const ComingSoon: React.FC = () => {

  return (
    <section className="relative h-[400px] md:h-[500px] flex items-center">
      {/* Background Image */}
      <img 
        src="/images/ComingSoon.webp" 
        alt="Coming Soon" 
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Content Overlay */}
      <div className="relative z-20 mx-auto px-4 md:px-10 lg:px-32 w-full pt-20 pb-20">
        <div className="w-full">
          {/* Heading */}
          <h1 className="text-[#FFFFFF] text-center text-[30px] md:text-[40px] lg:text-[65px] font-[700] leading-[45px] md:leading-[52px] lg:leading-[80px] lg:mb-2 mb-10 md:mb-8 w-full">
            Coming Soon
          </h1>
          
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
